import { useState } from "react";
import { entranceList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const statusStyle: Record<string, string> = {
  畅通: "border-accent-300 bg-accent-100 text-accent-800",
  备用: "border-secondary-300 bg-secondary-100 text-secondary-800",
};

export default function EntranceBoard() {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = async (domain: string, id: string) => {
    try {
      await navigator.clipboard.writeText(`https://${domain}`);
    } catch {
      // 剪贴板不可用时也给出提示
    }
    setCopied(id);
    window.setTimeout(() => setCopied((current) => (current === id ? null : current)), 1800);
  };

  return (
    <section
      id="entrances"
      className="w-full scroll-mt-20 border-b border-background-200 bg-background-50 py-14 md:py-20"
    >
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="最新可用入口"
            title="久久视频最新地址合集，一键复制直接访问"
            desc="以下线路均按实时监测结果排序，状态为「畅通」的地址可以直接访问，失效时改选其它线路即可。"
          />
          <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-100 px-4 py-3 text-xs text-foreground-600">
            <span className="flex h-4 w-4 items-center justify-center text-accent-600">
              <i className="ri-shield-check-line"></i>
            </span>
            状态每 5 分钟自动检测一次
          </div>
        </div>

        <ul className="mt-10 flex flex-col gap-3">
          {entranceList.map((item) => (
            <li
              key={item.id}
              className="rise flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:flex-row md:items-center md:justify-between md:p-5"
            >
              <div className="flex min-w-0 flex-1 items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-global-line text-xl"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {item.name}
                    </h3>
                    <span className="rounded-full border border-secondary-300 bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                      {item.type}
                    </span>
                  </div>
                  <p className="mt-1.5 break-all font-label text-sm text-primary-700">
                    https://{item.domain}
                  </p>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                </div>
              </div>

              <div className="flex shrink-0 items-center justify-between gap-3 md:justify-end">
                <div className="flex items-center gap-2">
                  <span
                    className={`rounded-full border px-2.5 py-1 text-xs font-medium ${
                      statusStyle[item.status] ?? statusStyle["备用"]
                    }`}
                  >
                    {item.status}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-speed-up-line"></i>
                    </span>
                    {item.latency}
                  </span>
                </div>
                <button
                  type="button"
                  onClick={() => handleCopy(item.domain, item.id)}
                  className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className={copied === item.id ? "ri-check-line" : "ri-file-copy-line"}></i>
                  </span>
                  {copied === item.id ? "已复制" : "复制地址"}
                </button>
              </div>
            </li>
          ))}
        </ul>

        <p className="mt-6 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
          <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
            <i className="ri-information-line"></i>
          </span>
          提示：本站不存储任何影片资源，仅整理公开可访问的入口地址，具体内容请以打开后的站点为准。
        </p>
      </div>
    </section>
  );
}